import { pluck, filter, map } from 'rxjs/operators'
import { ofType, combineEpics, ActionsObservable, StateObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { ReduxAction, State } from '../../../reducers/reducerType'
import trackActions from '../../../actions/tracks'

export const addDialIn$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(roomTypes.SET_DIALED_IN_PRESENTER),
  pluck<ReduxAction, string>('payload'),
  filter((identity) =>
    state$.value.user.BTID !== null && identity.includes(state$.value.user.BTID)
  ),
  map(() => trackActions.removeLocalAudioTrackDueToDialIn(state$.value.room.room))
)

export default combineEpics(addDialIn$)
